<template>
  <div class="container text-center mt-4">
    <div class="head-title pb-0 px-4">
      <h2 class="text-uppercase">Inventory</h2>
    </div>
    <div class="back-btn">
      <router-link to="/dashboard">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </router-link>
    </div>
    <section class="inventory-section mt-4">
      <div class="row">
        <div class="col-md-2">
          <form action="#" class="search-input">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="{2}"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
            <input
              type="search"
              placeholder="search"
              v-model="searchTerm"
              @keyup="search($event)"
              @paste="search($event)"
            />
          </form>
          <div class="btn-container">
            <a
              href="javascript:void(0)"
              class="md-btn pulse"
              :class="`${searchTerm == 'ships' ? 'selected' : ''}`"
              @click="filter('ships')"
              >ships</a
            >
            <a
              href="javascript:void(0)"
              class="md-btn pulse"
              :class="`${searchTerm == 'captains' ? 'selected' : ''}`"
              @click="filter('captains')"
              >character</a
            >
            <a
              href="javascript:void(0)"
              class="md-btn pulse"
              :class="`${searchTerm == 'ports' ? 'selected' : ''}`"
              @click="filter('ports')"
              >Ports</a
            >
            <a
              href="javascript:void(0)"
              class="md-btn pulse"
              :class="`${searchTerm == 'supplies' ? 'selected' : ''}`"
              @click="filter('supplies')"
              >supplies</a
            >
            <a
              href="javascript:void(0)"
              class="md-btn pulse"
              :class="`${searchTerm == 'foods' ? 'selected' : ''}`"
              @click="filter('foods')"
              >food stock</a
            >
            <a
              href="javascript:void(0)"
              class="md-btn pulse"
              :class="`${searchTerm == 'packs' ? 'selected' : ''}`"
              @click="filter('packs')"
              >Packs</a
            >
            <a
              href="javascript:void(0)"
              class="md-btn pulse"
              :class="`${searchTerm == 'coins' ? 'selected' : ''}`"
              @click="filter('coins')"
              >Coins</a
            >
            <a
              href="javascript:void(0)"
              class="md-btn pulse"
              :class="`${searchTerm == 'equipments' ? 'selected' : ''}`"
              @click="filter('equipments')"
              >Equipments</a
            >
          </div>
        </div>
        <div class="col-md-10 text-left">
          <loading
            v-model:active="isLoading"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="fullPage"
          />
          <div class="inventory-card">
            <div class="row mx-4">
              <div class="col-md-4" v-for="(item, index) in info" :key="index">
                <div class="card">
                  <vue-load-image>
                    <template v-slot:image>
                      <div class="img-wrapper">
                        <a href="#" class="img-position single-pic">
                          <div class="img-prev">
                            <img :src="getImgUrl(item.data.img)" alt="" />
                          </div>
                        </a>
                      </div>
                    </template>
                    <template v-slot:preloader>
                      <img class="card-img-top" src="/lostsailor/images/loader.gif" />
                    </template>
                    <template v-slot:error>Image load fails</template>
                  </vue-load-image>
                  <div class="card-body">
                    <h4 class="card-title m-0 asset-name">
                      {{ item.data.name }}
                      <span
                        class="text-danger text-right text-sm"
                        v-if="item.data.totaluse"
                        >Used: {{ item.data.use }}/{{
                          item.data.totaluse
                        }}</span
                      >
                    </h4>
                    <div class="buttons mt-2">
                      <button
                        class="small-btn"
                        @click="redirectToDetails(item.asset_id)"
                      >
                        Details
                      </button>
                      <button
                        @click.prevent="open(item.asset_id)"
                        class="small-btn ml-5 bg-white text-black"
                        v-if="
                          item.schema.schema_name == 'packs' &&
                          item.data.name == 'Token Pack'
                        "
                      >
                        Open
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h1 v-if="info && !info.length" style="margin-right: 212px">
              no data found.
            </h1>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import router from "@/router";
// import LoginService from "../services/LoginService";
import ApiService from "../services";
import VueLoadImage from "vue-load-image";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  name: "Inventory",
  components: {
    Loading,
    "vue-load-image": VueLoadImage,
  },
  data() {
    return {
      userFilter: null,
      authenticator: null,
      userCollection: "midgardclash",
      info: null,
      apiRes: null,
      searchTerm: "ships",
      isLoading: false,
      fullPage: true,
      status: false,
      assetId: "",
      row: {},
      assetIds: [],
      showModal: false,
      showStackModal: false,
      error: false,
      activeMenuSearch: false,
      activeMenu: false,
    };
  },
  mounted() {
    this.init(`&page=1&limit=100&schema_name=${this.searchTerm}`);
  },
  methods: {
    redirectToDetails(id) {
      router.push(`/details/${id}`);
    },
    calculatePrice(price) {
      if (price !== undefined && price.length > 0) {
        return `${Number(price[0].average / 100000000).toFixed(2)} ${
          price[0].token.token_symbol
        }`;
      }
    },
    pricetoUSD(price) {
      if (price !== undefined && price.length > 0) {
        return `($${Number((price[0].average / 100000000) * 0.3416).toFixed(
          2
        )})`;
      }
    },
    init(params) {
      this.isLoading = true;
      ApiService.genericCall(
        `collection_name=lostsailorsl${params}`,
        (response) => {
          let res = response["data"];
          if (res["success"]) {
            this.apiRes = res["data"];
            this.info = res["data"];
            this.status = true;
          } else {
            this.info = [];
            this.status = false;
          }
          this.loading = false;
          this.isLoading = false;
        }
      );
    },
    filter(term) {
      this.searchTerm = term;
      this.init(`&page=1&limit=100&schema_name=${term}`);
    },
    search() {
      const params = ApiService.makeRequestParams(this.searchTerm);
      this.init(params);
    },
    getImgUrl(hash) {
      let url = "http://ipfs.io/ipfs/" + hash;
      return "//lostsailor/images.weserv.nl/?url=" + url + "&w=500";
    },
    async open(asset) {
      const data = {
        from: localStorage.getItem("wax_user"),
        to: process.env.VUE_APP_CONTRACT,
        asset_ids: [asset],
        memo: `openpack`,
      };
      await ApiService.attack(
        data,
        (res) => {
          if (res.processed) {
            toast.success("Transaction successfull");
            this.$store.commit("updateBalance", 10000);
          }
        },
        (error) => {
          this.error = ApiService.errorFormat(error);
          toast.error(this.error);
        }
      );
    },
  },
};
</script>

<style scoped>
.card-body {
  margin-bottom: 20px;
}
</style>